var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M103.1,58.61c-2.01-6.24-4.98-12.85-8.83-19.63-6.34-11.17-15.26-23.21-27.27-36.81-.89-1-2.15-1.56-3.48-1.56-.09,0-.18,0-.26,0h0c-1.24.06-2.43.63-3.26,1.56-12.01,13.6-20.93,25.64-27.27,36.81-3.85,6.78-6.82,13.39-8.83,19.63-2.21,6.86-3.32,13.53-3.32,19.81s1.12,12.64,3.34,18.53c2.15,5.71,5.22,10.85,9.14,15.27,8.11,9.14,18.92,14.17,30.45,14.17s22.34-5.03,30.45-14.17c3.92-4.42,6.99-9.55,9.14-15.27,2.22-5.89,3.34-12.12,3.34-18.53s-1.12-12.95-3.32-19.81ZM87.15,105.86c-6.35,7.21-14.75,11.19-23.65,11.19s-17.3-3.97-23.65-11.19c-6.41-7.28-9.94-17.03-9.94-27.44,0-9.3,3.35-20.17,9.94-32.3,5.56-10.23,13.43-21.38,23.4-33.14l.24-.29.24.29c9.96,11.76,17.84,22.91,23.4,33.14,6.6,12.13,9.94,23,9.94,32.3,0,10.41-3.53,20.16-9.94,27.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M39.77,71.65c-2.58.05-4.7,2.05-4.89,4.63-.99,11.05,3.97,22.78,12.42,28.95,2.15,1.72,5.29,1.38,7.02-.77,1.72-2.15,1.38-5.29-.77-7.02-.12-.09-.24-.18-.37-.27-4.42-3.23-8.93-13.16-8.32-20.01.29-2.74-1.7-5.2-4.44-5.48-.22-.02-.43-.03-.65-.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.94390085af2e0b19c1135c5ebda32758.svg";
export { ForwardRef as ReactComponent };